import * as React from 'react';
import PropTypes from 'prop-types';
import ContrastContext from '../context/contrastContext';
import Hero from '../components/Hero';
import Section from '../components/Section';

function IndexPage({ heroImage, heroContent }) {

  return (
    <>
      <Hero image={heroImage} content={heroContent} autoHeaderText={true} />
      <Section colorScheme="black">
        <ContrastContext.Consumer>
          {(context) => (
            <div className="container py-12"></div>
          )}
        </ContrastContext.Consumer>
      </Section>
    </>
  );
}

IndexPage.propTypes = {
  heroImage: PropTypes.object.isRequired,
  heroContent: PropTypes.string.isRequired,
};

export default IndexPage;
